import { diContainer, serviceNames } from '../diContainer/diContainer';
import AnalyticsRepository from '../repositories/AnalyticsRepository';
import UserPreferencesRepository from '../repositories/UserPreferencesRepository';

class SubmitNewsletterUseCase {
  private userPreferencesRepository: UserPreferencesRepository;

  private analyticsRepository: AnalyticsRepository;

  constructor() {
    this.userPreferencesRepository = diContainer.get(serviceNames.userPreferencesRepository);
    this.analyticsRepository = diContainer.get(serviceNames.analyticsRepository);
  }

  public async execute(): Promise<void> {
    const { userPreferences, isSubscribed } = this.userPreferencesRepository;
    if (userPreferences.subscribed !== isSubscribed) {
      this.userPreferencesRepository.updateSubscription(userPreferences);
      if (window.utag_data) {
        // save newsletter in utag_data so it can be used for events on payment page
        // eslint-disable-next-line @typescript-eslint/naming-convention
        window.utag_data.pc_email_optin = userPreferences.subscribed ? 1 : 0;
      }
      if (userPreferences.subscribed) {
        this.analyticsRepository.signUpForNewsletterLinkEvent();
      }
    }
  }
}

export default SubmitNewsletterUseCase;
